exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-search-results{min-height:70vh}.is-checkradio[type=checkbox].no-bgcolor+label,.is-checkradio[type=checkbox].no-bgcolor:hover{background:#fff!important}", ""]);

// exports
